<template>
  <DocsLayout
    heading="Help"
    :content="articles"
    :navigation="categories"
    :html-based="true"
    :selected-nav="selectedCategory"
    :selected-article="selectedArticle"
    @sideBarLinkClicked="handleCategoryClicked"
  />
</template>

<script>
import DocsLayout from "@/layouts/DocsLayout.vue";

export default {
  name: "Help",
  components: {
    DocsLayout,
  },
  data() {
    return {
      categories: [],
      articles: [],
      selectedCategory: null,
      defaultCategory: null,
      selectedArticle: null,
      selectedCategoryIndex: 0,
    };
  },
  async mounted() {
    await this.getCategories();

    // Get category in url if it exists
    const url = new URL(window.location);
    const categorySlug = url.searchParams.get("category");
    this.selectedArticle = url.searchParams.get("article");

    const matchedCategory = this.categories.find(
      (category) => category.slug === categorySlug
    );

    // Set the selected category as the first category by default
    if (matchedCategory) {
      this.selectedCategoryIndex = this.categories.indexOf(matchedCategory);
      this.selectedCategory = matchedCategory;
    } else {
      this.defaultCategory = this.categories[0];
    }

    // Get articles
    const categoryId = this.selectedCategory?.id || this.defaultCategory.id;
    await this.getArticlesByCategory(categoryId);
  },
  methods: {
    async getCategories() {
      const categoriesResponse = await fetch(
        process.env.RATANDBOA_NODE_APP_URL + "/helpdocs/categories"
      );

      const json = await categoriesResponse.json();
      this.categories = json;
    },
    handleCategoryClicked(category) {
      this.selectedCategory = category;
      this.setHelpUrl(category);

      if (category) {
        this.selectedCategoryIndex = this.categories.indexOf(category);
        this.getArticlesByCategory(category.id);
      }
    },
    async getArticlesByCategory(categoryId) {
      this.articles = [];

      const articlesResponse = await fetch(
        process.env.RATANDBOA_NODE_APP_URL +
          "/helpdocs/articlesByCategory?categoryId=" +
          categoryId
      );

      const json = await articlesResponse.json();

      const articlesWithUrl = json.map((article) => {
        const url = new URL(window.location);
        url.searchParams.set(
          "category",
          this.selectedCategory?.slug || this.defaultCategory.slug
        );
        url.searchParams.set("article", article.slug);

        return {
          ...article,
          url: url.toString(),
          index: this.selectedCategoryIndex,
        };
      });

      this.articles = articlesWithUrl;
    },
    setHelpUrl(category) {
      const url = new URL(window.location);

      if (category) {
        url.searchParams.set("category", category.slug);
      } else {
        url.searchParams.delete("category");
      }

      window.history.pushState(null, "", url.toString());
    },
  },
};
</script>
